// Author yjb
// Date 2022-02-07 14:49:16

import * as model from "@/model/em/statusCollection/ImfEmSicIesmrReasonIesmrrModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ImfEmSicIesmrReasonIesmrr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'imfEmSicIesmrReasonIesmrr',
        modelFilter: model.filter
    })
    .buildStore()
